import { FunctionComponent, useEffect, useState, useCallback } from 'react'
import useStyles from './styles'
import { capitalize } from '@/utils/capitalize'

import dayjs, { Dayjs } from 'dayjs'
import ptBR from 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.locale(ptBR)
dayjs.extend(utc)
dayjs.extend(timezone)

export const TimeZoneGMT: FunctionComponent = () => {
  const { footer } = useStyles()
  const [parsedDate, setParsedData] = useState<string>()

  const parseDate = useCallback((date: Dayjs) => {
    const parsedDate = date.format('DD/MM/YYYY, dddd - HH:mm:ss')
    const timeZoneText = 'Brasil (UTC-3) - Horário de Brasília'
    return `${capitalize(parsedDate)} - ${timeZoneText}`
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      const dt = dayjs()
      dt.tz('America/Sao_Paulo')

      const parsedDt = parseDate(dt)
      setParsedData(parsedDt)
    }, 1000)

    return () => clearInterval(interval)
  }, [parseDate])

  return (
    <div css={footer}>
      <span>{parsedDate}</span>
    </div>
  )
}
